var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarOnly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 562,
    viewBox: "0 0 492 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246 281C283.282 281 319.037 266.197 345.399 239.849C371.761 213.5 386.571 177.763 386.571 140.5C386.571 103.237 371.761 67.5004 345.399 41.1515C319.037 14.8026 283.282 0 246 0C208.718 0 172.963 14.8026 146.601 41.1515C120.239 67.5004 105.429 103.237 105.429 140.5C105.429 177.763 120.239 213.5 146.601 239.849C172.963 266.197 208.718 281 246 281ZM195.812 333.688C87.6375 333.688 0 421.28 0 529.4C0 547.401 14.6063 562 32.617 562H459.383C477.394 562 492 547.401 492 529.4C492 421.28 404.363 333.688 296.188 333.688H195.812Z",
    fill: "#C5C5C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 492,
    height: 562,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarOnly);
export default __webpack_public_path__ + "static/media/avatar-only.f2107915e0dd2a7bcd8abd253423f77e.svg";
export { ForwardRef as ReactComponent };